<template>
    <div class="position-relative">
        <app-loader v-if="pageLoader"/>
        <router-view />
    </div>
</template>
<script>
import { commonAllmixins } from "@/plugins/commonAll";
const product = process.env.product;
export default {
    mixins: [commonAllmixins],
    data(){
        return{
            pageLoader : false
        }
    },
    watch : {
        "$route"(){
            if(this.$route.name == 'leaders' && !this.$route.query.leaderboard){
                this.getLeadersData();
            }else if(this.$route.query.leaderboard){
                this.getAllLeaders();
            }else if(this.$route.name == 'leader-detail'){
                this.getLeaderDetail();
            }
        }
    },
    methods: {
        getLeadersData(){
            this._runGetLeadersList({ globalParams: {}, localParams: { parameter: this } });
        },
        getLeaderDetail(){
            this._runGetLeadersDetail({ globalParams: { 'provider_id' : this.divide9(this.$route.query.id) }, localParams: { parameter: this } });
        },
        getAllLeaders(){
            let filter = {
                "size": 15,
                "sortAsc": false,
                "page": 0,
                "bringDetailedChart": false
            }
            this._runGetAllLeadersList({ globalParams: filter, localParams: { parameter: this } });
        },
        fetchLeadersData() {
            if(this.$route.name == 'leaders' && !this.$route.query.leaderboard){
                // this.getLeadersData();
            }else if(this.$route.query.leaderboard){
                this.getAllLeaders();
            }else if(this.$route.name == 'leader-detail'){
                this.getLeaderDetail();
            }
            this._runGetFollowersSetting({ globalParams: {}, localParams: { parameter: this } });
        }
    },
    created() {
        const token = this.$store.getters['GET_TOKEN'] || '';
        if (product != 'market101') {
            this.$router.replace('/');
        } else if (token && product == 'market101') {
            this.getLeadersData()
            this._runGetCopytradingToken({ globalParams: {}, localParams: { parameter: this } });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/main.vue